import Vue from 'vue';
import Router from 'vue-router';
import Confirm from './views/Confirm.vue';
import Stores from './views/Stores.vue';
import Personalise from './views/Personalise.vue';
import ThankYou from './views/ThankYou.vue';
import TermsConditions from './views/TermsConditions.vue';
import Canberra from './views/Canberra.vue';
import NotFound from './views/NotFound.vue';
import Error from './views/Error.vue';

Vue.use(Router);

// https://github.com/vuejs/vue-router/blob/dev/examples/route-matching/app.js

const router = new Router({
  routes: [
    {
      path: '/pdf/:pdf',
      name: 'pdf',
      meta: {
        title: 'Raffle Terms and Conditions',
      },
    },
    {
      path: '/confirm/:crmId/:name/:email/:store?',
      name: 'confirm',
      component: Confirm,
      props: true,
      meta: {
        title: 'Confirm your Nike membership today',
      },
      // redirect: '/sorry',
    },
    {
      path: '/personalise-membership/:crmId/:name/:email/:store?',
      name: 'personalise',
      component: Personalise,
      props: true,
      meta: {
        title: 'My Nike preferences',
      },
      // redirect: '/sorry',
    },
    {
      path: '/canberra',
      name: 'canberra',
      component: Canberra,
      props: true,
      meta: {
        title: 'Nike Canberra is coming',
      },
      redirect: '/404',
    },
    {
      path: '/participating-nike-stores',
      name: 'stores',
      component: Stores,
      meta: {
        title: 'Participating Nike stores',
      },
    },
    {
      path: '/thank-you/:store?',
      name: 'thank-you',
      component: ThankYou,
      props: true,
      meta: {
        title: 'Thank You',
      },
    },
    {
      path: '/thank-you-for-personalise-membership/:store?',
      name: 'thank-you-personalise',
      props: true,
      component: ThankYou,
      meta: {
        title: 'Thank You',
      },
    },
    {
      path: '/thank-you-canberra',
      name: 'thank-you-canberra',
      props: true,
      component: ThankYou,
      meta: {
        title: 'Thank You',
      },
      redirect: '/404',
    },
    {
      path: '/terms-conditions',
      name: 'terms',
      component: TermsConditions,
      meta: {
        title: 'Terms and Conditions',
      },
    },
    {
      path: '/sorry',
      name: 'error',
      component: Error,
      meta: {
        title: 'Sorry',
      },
    },
    {
      path: '/404',
      component: NotFound,
      meta: {
        title: '404',
      },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
